import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import React from "react";

interface ProgressBannerProps {
  color: string;
  label: string | React.ReactNode;
  numerator?: number;
  denominator?: number;
  loading?: boolean;
  checkbox?: {
    show: boolean;
    checked: boolean;
    label: string | React.ReactNode;
    onChange: () => void;
  };
}

interface StyleProps {
  color: string;
}

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: (props: StyleProps) =>
      props.color
        ? theme.palette[props.color].main
        : theme.palette.primary.main,
    color: (props: StyleProps) =>
      props.color
        ? theme.palette[props.color].contrastText
        : theme.palette.primary.contrastText,
    padding: "3px",
  },
  checkbox: {
    padding: "0 5px 0 0",
    color: (props: StyleProps) => theme.palette[props.color].contrastText,
    "&.MuiCheckbox-colorSecondary.Mui-checked": {
      color: (props: StyleProps) => theme.palette[props.color].contrastText,
    },
  },
  label: {
    color: (props: StyleProps) => theme.palette[props.color].contrastText,
  },
}));

function ProgressBanner(props: ProgressBannerProps) {
  const {
    label,
    color = "primary",
    numerator = 0,
    denominator = 0,
    checkbox,
    loading,
    ...rest
  } = props;
  const classes = useStyles({ color });
  return (
    <Box role="marquee" className={classes.banner} {...rest}>
      <Grid container>
        <Grid item xs={false} sm={4} />
        <Grid item xs={6} sm={4}>
          <Box
            textAlign="center"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {loading ? (
              <Skeleton
                variant="text"
                animation="wave"
                width={130}
                height={20}
              />
            ) : (
              <Typography variant="body2" style={{ color: "inherit" }}>
                <strong>{`${numerator} / ${denominator} ${
                  label || ""
                }`}</strong>
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={6} sm={4}>
          <Box style={{ float: "right" }}>
            {checkbox?.show && (
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={checkbox?.checked}
                      onChange={() => checkbox?.onChange()}
                      className={classes.checkbox}
                    />
                  }
                  label={
                    <Typography variant="body2" className={classes.label}>
                      {checkbox?.label}
                    </Typography>
                  }
                />
              </FormGroup>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ProgressBanner;
